import { BaseDto } from '../base.dto';
import { IsDefined, IsInt, IsOptional, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '../../constants';

export class BankingCompVoidRefundApprovalDto extends BaseDto {
  @IsOptional()
  @IsDefined()
  @IsInt()
  orderId: number;

  @IsOptional()
  @IsDefined()
  @IsInt()
  orderPosTableProductId: number;

  @IsDefined()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description:string;

  @IsDefined()
  @IsInt()
  compRefundCategoryId: number;

  @IsOptional()
  @IsInt()
  approvedUserId: number;

  @IsOptional()
  @IsInt()
  approvedEmployeeId: number;
}
